var app = angular.module('tf.popups', [])

    .controller('upgradeBrowserCtrl', ['$scope', '$uibModalInstance', '$window', 'reason', '$localStorage', function gamePopupsController($scope, $uibModalInstance, $window, reason, $localStorage) {

        $scope.reason = reason;

        $scope.goToChromeDownLoad = function() {
            $window.open('https://www.google.com/chrome/browser/desktop/index.html');
            $localStorage.acceptBrowserSuggest = true;
            $uibModalInstance.dismiss('okay');
        };

        $scope.goToFirefoxDownLoad = function() {
            $window.open('https://www.mozilla.org/en-US/firefox/new/');
            $localStorage.acceptBrowserSuggest = true;
            $uibModalInstance.dismiss('okay');
        };

        $scope.goToIEDownLoad = function() {
            $window.open('http://windows.microsoft.com/en-AU/internet-explorer/download-ie');
            $localStorage.acceptBrowserSuggest = true;
            $uibModalInstance.dismiss('okay');
        };

        $scope.cancel = function () {
            $localStorage.acceptBrowserSuggest = true;
            $uibModalInstance.dismiss('cancel');
        };



    }])

    ;
